export default "__VITE_ASSET__CK$llBZZ__"